import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Dropdown } from "primeng/dropdown";
import { SubSink } from "subsink";
import { AutomapperService } from "../../../core/automapper/automapper.service";
// import { RiskService } from "../../../platform/modules/member/chase-detail/chase-detail-chart/risk/risk.service";
// import { NationalProviderGridService } from "../../../shared/national-provider-grid/national-provider-grid.service";
// import { MasterProvider } from "../../../shared/national-provider-grid/national-provider.model";
import { DynamicControlComponent } from "../../dynamic-control-component.model";
import { FormService } from "../../form.service";
import { ProviderDropdown } from "./provider-dropdown.model";

@Component({
  selector: "app-provider-dropdown",
  templateUrl: "./provider-dropdown.component.html",
  styleUrls: [
    "../textbox/textbox.component.scss",
    "../dropdown/dropdown.component.scss",
    "./provider-dropdown.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // providers: [RiskService], // NOTE: Keep commented out. Only here for testing.
})
export class ProviderDropdownComponent extends DynamicControlComponent<ProviderDropdown> implements OnInit, OnDestroy {
  private sink = new SubSink();

  @ViewChild("providerDropdown", { static: true }) primeProviderDropdown: Dropdown;
  visibleProviderSearchModal = false;
  providerSearchText: string;


  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formService: FormService,
    // private readonly nationalProviderGridService: NationalProviderGridService,
    // private readonly riskService: RiskService,
    private readonly automapper: AutomapperService
  ) {
    super();
  }

  ngOnInit() {
    this.sink.add(
      this.control.statusChanges.subscribe(() => this.changeDetector.markForCheck()),
      this.formService.updateDom.subscribe(() => this.changeDetector.markForCheck())
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
  }


  get classes(): string {
    return this.getClasses("dropdown");
  }

  get options(): any[] {
    return this.model.options;
  }

  get enableSearch(): boolean {
    return !this.model.disabled && !this.model.isAdmin;
  }

  get visibleProviderSearchModalHack(): boolean {
    return this.visibleProviderSearchModal && this.enableSearch;
  }

  search(event: MouseEvent | null): void {
    if (event != null) {
      event.stopPropagation();
      event.preventDefault();
    }

    // this.nationalProviderGridService.search(this.providerSearchText);
  }

  openProviderSearchModal(): void {
    this.providerSearchText = "";
    // this.nationalProviderGridService.data = [];
    this.visibleProviderSearchModal = true;
    this.changeDetector.markForCheck();
  }

  closeProviderSearchModal(): void {
    this.visibleProviderSearchModal = false;
    this.providerSearchText = "";
    // this.nationalProviderGridService.data = [];
    this.changeDetector.markForCheck();
  }

  // addAndSelect(provider: MasterProvider) {
  //   const hasProvider = this.options.some(a => a.extra.nationalProviderId === provider.nationalProviderId);
  //   if (hasProvider) {
  //     this.setValueByMasterProvider(provider);
  //   } else {
  //     const chaseId = this.model.saveInfo.chaseId;
  //     this.nationalProviderGridService.addServiceProvider(chaseId, provider)
  //       .subscribe(providers => {
  //         this.riskService.data.value.providers = providers;
  //         this.model.options = providers.map(this.automapper.curry("Provider", "SelectableInput"));
  //         this.setValueByMasterProvider(provider);
  //       });
  //   }
  // }

  // private setValueByMasterProvider({ nationalProviderId }: MasterProvider): void {
  //   const selectedOption = this.model.options.find(a => a.extra.nationalProviderId === nationalProviderId);
  //   if (selectedOption != null) {
  //     const value = selectedOption.value;
  //     this.model.saveInfo.value = value;
  //     this.control.setValue(value);
  //     this.closeProviderSearchModal();
  //     this.primeProviderDropdown.focus();
  //   }
  // }
}
